import { makeStyles } from "@material-ui/core";
import { KeyboardTimePicker } from "@material-ui/pickers";
import moment from "moment";
import { useState } from "react";
import { useField } from "react-final-form";

interface ICustomTimePickerInput {
  source: string;
  label: string;
}

const useStyles = makeStyles({
  root: {
    width: "100%",
    marginTop: "8px",
    paddingBottom: "3px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#EAEAEA",
      },
      "& input": {
        padding: "16px 14px",
        backgroundColor: "#FFFFFF",
      },
      "&:hover fieldset": {
        borderColor: "#EAEAEA",
      },
    },
  },
});

export const getTimeFormatted = (fullDate: Date) => {
  const hour = ("0" + fullDate.getHours()).slice(-2);
  const minute = ("0" + fullDate.getMinutes()).slice(-2);
  const second = ("0" + fullDate.getSeconds()).slice(-2);

  return `${hour}:${minute}:${second}`;
};

export const convertDateTimeWithTimeOnly = (time: string) => {
  const fullDate = new Date();
  // fullDate = Tue Dec 12 2017 11:18:30 GMT+0530 (IST) {}

  const d = moment(fullDate).format("yyyy-MM-DD"); // d = "12/12/2017"
  const date = moment(d + " " + time).format();
  const jsDate = moment(date).toDate();

  return jsDate;
};

const CustomTimePickerInput = ({ source, label }: ICustomTimePickerInput) => {
  const classes = useStyles();

  const {
    input: { onChange, value },
  } = useField(source);

  const [time, setTime] = useState<any>(
    value ? convertDateTimeWithTimeOnly(value) : null
  );

  return (
    <KeyboardTimePicker
      className={classes.root}
      ampm={false}
      label={label}
      value={time}
      onChange={(e: any) => {
        if (e) {
          setTime(new Date(e));
          onChange(getTimeFormatted(new Date(e)));
        } else {
          setTime(null);
          onChange(null);
        }
      }}
      inputVariant="outlined"
      variant="inline"
    />
  );
};

export default CustomTimePickerInput;
